<div *ngIf="isLoaded">
  <div class="rejection-details" *ngIf="taskStatus && ['Rejected'].includes(taskStatus)">
    <app-rejection-details [supplierCode]='supplierCode' [rejectionDetails]='rejectionDetails'></app-rejection-details>
  </div>
  <div *ngIf="taskStatus && ['New', 'Rejected'].includes(taskStatus); else OtherContact">
    <h3 *ngIf="!isSidePanelMode" class="mb-3 header" i18n="@@Contacts" t="Contacts">Contacts</h3>
    <div class="contextVerbiage" *ngIf="contextVerbiage">
      <div class="flex-container">
        <div class="flex-items">
          <tsl-icon style="color: #3E6AE1">info_blue</tsl-icon>
        </div>
        <div class="flex-items">
          <tsl-label style="color: #3E6AE1">{{ translate.get(contextVerbiage.contact.details?.description)
            }}</tsl-label>
        </div>
      </div>
    </div>

    <!-- contact info status banner -->
    <div *ngIf="!isIncompleteTabs;else incomplete" class="flex-container complete">
      <div class="flex-items">
        <tsl-icon style="color: #12BB00;">check_circle</tsl-icon>
      </div>
      <div class="flex-items">
        <tsl-label i18n="@@contactTaskVerbiage2" t="contactTaskVerbiage2">All contacts required for proper Supplier
          Relationship Management Portal access have been assigned.</tsl-label>
      </div>
    </div>
    <ng-template #incomplete>
      <div class="flex-container incomplete">
        <div class="flex-items">
          <tsl-icon class="warning">warning</tsl-icon>
        </div>
        <div class="flex-items">
          <tsl-label i18n="@@warningForNoMoreThanOneOrMoreContacts" t="warningForNoMoreThanOneOrMoreContacts">All below
            contact purposes need to have either a new or existing contact assigned in order for you
            to be able to complete your New Supplier Onboarding</tsl-label>
        </div>
      </div>
    </ng-template>
    <table *ngIf="isLoaded">
      <thead class="tsl-header-row">
        <tr>
          <th class="tsl-header-cell" i18n="@@Status" t="Status">Status</th>
          <th class="tsl-header-cell" i18n="@@ContactName" t="ContactName">Contact Name</th>
          <th class="tsl-header-cell" i18n="@@ContactPurpose" t="ContactPurpose">Contact Purpose</th>
          <th class="tsl-header-cell" style="width: 40%;" i18n="@@Description" t="Description">Description</th>
          <th class="tsl-header-cell" style="width: 131px;" i18n="@@Actions" t="Actions">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr class="tsl-row" *ngFor="let ct of contactTabsData; index as idx">
          <td class="tsl-cell">
            <tsl-icon *ngIf="ct.contact && SupplierContact.isValid(ct.contact);else NoStatus"
              style="color: #12BB00;">check
            </tsl-icon>
            <ng-template #NoStatus>
              <div
                *ngIf="(missingTabs && missingTabs.includes(ct.type)) || ( missingTabs && !ct.Email);else incompleteTab">
                <tsl-icon style="color: #FBB01B;">warning</tsl-icon>
              </div>
              <ng-template #incompleteTab>
                <tsl-icon>maximize</tsl-icon>
              </ng-template>
            </ng-template>
          </td>
          <td class="tsl-cell">
            <div *ngIf="ct.contact != null;else NoContact">
              {{ ct.contact.FirstName }} {{ ct.contact.LastName }}
            </div>
            <ng-template #NoContact>
              <div i18n="@@NotAdded" t="NotAdded">Not Added</div>
            </ng-template>
          </td>
          <td class="tsl-cell">
            {{ ct.type == 'My Details' ? 'My Information' : ct.type }}
            <span [ngSwitch]="ct.type" *ngIf="contextVerbiage && contextVerbiage.contact">
              <tsl-icon *ngSwitchCase="'My Details'" matTooltip="{{contextVerbiage.contact?.details?.subDescription}}"
                style="color: #3E6AE1" size="small">info_outline</tsl-icon>
              <tsl-icon *ngSwitchCase="'Primary'" matTooltip="{{contextVerbiage.contact?.primary?.subDescription}}"
                style="color: #3E6AE1" size="small">info_outline</tsl-icon>
              <tsl-icon *ngSwitchCase="'Sales'" matTooltip="{{contextVerbiage.contact?.sales?.subDescription}}"
                style="color: #3E6AE1" size="small">info_outline</tsl-icon>
              <tsl-icon *ngSwitchCase="'Finance Lead'"
                matTooltip="{{contextVerbiage.contact?.financeLead?.subDescription}}" style="color: #3E6AE1"
                size="small">info_outline</tsl-icon>
              <tsl-icon *ngSwitchCase="'Remit To'" matTooltip="{{contextVerbiage.contact?.remitTo?.subDescription}}"
                style="color: #3E6AE1" size="small">info_outline</tsl-icon>
              <tsl-icon *ngSwitchCase="'Material Planning'"
                matTooltip="{{contextVerbiage.contact?.materialPlanning?.subDescription}}" style="color: #3E6AE1"
                size="small">
                info_outline</tsl-icon>
              <tsl-icon *ngSwitchCase="'Contractor Responsible Person'"
                matTooltip="{{contextVerbiage.contact?.crp?.subDescription}}" style="color: #3E6AE1" size="small">
                info_outline</tsl-icon>
              <tsl-icon *ngSwitchCase="'Environment, Health and Safety'"
                matTooltip="{{contextVerbiage.contact?.ehs?.subDescription}}" style="color: #3E6AE1" size="small">
                info_outline
              </tsl-icon>
            </span>
          </td>
          <td class="tsl-cell">
            <ng-container [ngSwitch]="ct.type">
              <div *ngSwitchCase="'My Details'" i18n="@@MyDetailsHeadMsg" t="MyDetailsHeadMsg">Your contact information.
              </div>
              <div *ngSwitchCase="'Primary'" i18n="@@PrimaryHeadMsg" t="PrimaryHeadMsg">The main point of contact for
                Tesla.</div>
              <div *ngSwitchCase="'Sales'" i18n="@@SalesHeadMsg" t="SalesHeadMsg">Receives purchase order (PO)
                notifications and other
                related details.</div>
              <div *ngSwitchCase="'Finance Lead'" i18n="@@FinanceLeadHeadMsg" t="FinanceLeadHeadMsg">The organization
                main contact for finance
                details and invoice notifications.</div>
              <div *ngSwitchCase="'Remit To'" i18n="@@RemitToHeadMsg" t="RemitToHeadMsg">Additional finance contact
                assigned to receive
                remittance details. Can be same as finance lead.</div>
              <div *ngSwitchCase="'Material Planning'" i18n="@@MpHeadMsg" t="MpHeadMsg">Only applicable for part
                suppliers, the
                contact for shipping.</div>
              <div *ngSwitchCase="'Contractor Responsible Person'" i18n="@@CrpHeadMsg" t="CrpHeadMsg">User will be able
                to access Workforce Management and
                MyEHS. Examples include managers of onsite operations and/or crew supervisors.</div>
              <div *ngSwitchCase="'Environment, Health and Safety'" i18n="@@EHSPersonHeadMsg" t="EHSPersonHeadMsg">The
                person in the organization responsible for safety
                and health program management.</div>
              <div *ngSwitchCase="'SubTier Profile Admin'" i18n="@@SamHeadMsg" t="SamHeadMsg">User will be able to
                access and update (add, edit, and
                delete) supplier's organization details for address, contacts, documents, supplier tasks within the
                Tesla Supplier Portal, the user will be the main point of contact for Tesla.</div>
              <div *ngSwitchCase="'SubTier Quality'" i18n="@@SQHeadMsg" t="SQHeadMsg">User will be able to access, take
                action on tasks, and receive
                emails related to part/process qualification applications on the Supplier Portal.</div>
            </ng-container>
          </td>
          <td class="tsl-cell">
            <button (click)="openContactEdit(ct)" tsl-icon-button *ngIf="ct.contact != null;else AddContact">
              <tsl-label style="color: #3E6AE1;" i18n="@@7585826646011739428" t="7585826646011739428">Edit</tsl-label>
            </button>
            <ng-template #AddContact>
              <button tsl-icon-button (click)="openContactEdit(ct)">
                <div style="display:flex;">
                  <tsl-icon status="error" style="color: #3E6AE1;">add_circle_outline</tsl-icon>
                  <div style="font-size: small; color: #3E6AE1;align-self: center;width: max-content;"
                    i18n="@@a99c09975ed76d8da13b0f8e552389c9ab8f2e43" t="a99c09975ed76d8da13b0f8e552389c9ab8f2e43">Add
                    Contact</div>
                </div>
              </button>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
    <button *ngIf="!isSidePanelMode" class="action-btn" tsl-button size="small" color="blue" filled (click)="submit()"
      i18n="@@Submit" t="Submit">Submit</button>
  </div>
  <ng-template #OtherContact>
    <h3>
      <span i18n="@@taskCompleteRedirect" t="taskCompleteRedirect">Task is already completed please go back to home
        page.</span>
      <a i18n="@@clickHere" t="clickHere" href="javascript:void(0)" (click)="navigateToHome()">Click Here</a>
    </h3>
  </ng-template>
</div>